import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
//import { AuthContext } from './context';
import axios from 'axios';
import { Form, Button, Modal } from 'react-bootstrap';
import ReactEcharts from 'echarts-for-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';


const GraphScreen = () => {

    //const { signOut } = React.useContext(AuthContext);
    const loginState = useSelector(state => state.currentLogin);
    const graphFields = useSelector(state => state.graphFields.checkboxes);
    const series = useSelector(state => state.graph.graphData);
    const [buttonColor, setButtonColor] = useState('#0D6EFD');
    const [startDate, setStartDate] = useState(null);  //new Date()
    const [endDate, setEndDate] = useState(null);  //new Date()
    const [startDateFormatted, setStartDateFormatted] = useState(null);
    const [endDateFormatted, setEndDateFormatted] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const handleModalClose = () => {setShowModal(false)}
    const handleModalShow = () => {setShowModal(true)}
    const dispatch = useDispatch();  //Assign dispatch so we can use it...
    /*
    const dataPost = {
        dataLoggerIdSet: ['AS20171007', 'AS201004'],  //dataLoggerId: 'AS20171007', 'AS201004'
        fromTimestamp: '2022-01-01 00:00:00.0',  
        toTimestamp: '2022-01-03 23:59:59.0', 
    }*/
    const dataPost = {
        dataLoggerIdSet: ['AS20171007', 'AS201004'],  // ['AS20171007', 'AS201004']
        //fromTimestamp: '2022-01-01 00:00:00.0',  //2022-01-03 17:00:00.0
        //toTimestamp: '2022-01-02 23:59:59.0',  //2022-01-05 18:00:00.0
        fromTimestamp: startDateFormatted, 
        toTimestamp: endDateFormatted, 
    }

    const option = {
        title: [
            {
                id: 0,
                text: 'AS20171007', 
                top: '0.1%', //y: '1%',
                left: '0.5%', //x: '1%',
                textStyle: {
                    color: 'red',
                    fontSize: 15,
                },
            },
            {
                id: 1,
                text: 'AS201004', 
                left: '0.5%',
                top: '50%', 
                textStyle: {
                    color: 'red',
                    fontSize: 15,
                },
            },
        ],
        tooltip: {
            trigger: 'axis', 
            padding: 3, 
        },
        grid: [
            {   //placement for graph 0
                left: '3%', 
                top: '7.5%', 
                width: '96%', 
                height: '35%', 
            },  
            {   //placement for graph 1
                left: '3%', 
                top: '58%', 
                width: '96%', 
                height: '35%', 
            },  
        ],
        dataZoom: [
            {
                type: 'inside',
                realtime: true,
                start: 0,
                end: 100,
                xAxisIndex: [0, 1]  //defines graph 0 & 1 x-axis to be zoomed, pinch and zoom
            }
        ],
        xAxis: [
            {gridIndex: 0, type: 'time', },
            {gridIndex: 1, type: 'time', },
        ],
        yAxis: [
            {gridIndex: 0},
            {gridIndex: 1},
        ],
        series: series
    }

    const getDataLoggerFieldList = async () => {  //Fn-1.1 get the list of dataLoggerFields from DB, then update useState {checkboxFieldList}
        console.log('[Fn-1.1] getDataLoggerFieldList');
        await axios.get('/dataLogger/listDataLoggerField', { headers: { Authorization: loginState.token} })
            .then(response => {
                updateCheckboxFieldList(response.data); //Fn-1.2 - update the dataLogger field names from DB => setState {setCheckboxFieldList}
            })
            .catch((error) => { 
                console.log('[Error] getDataLoggerFieldList(): ', error);  //failed to get data
                if(error.response.status === 403){  //If Error 403 means user is not authorised or Token has expired, route back to login screen...
                    //should call for modal informing users first before signOut...
                    //signOut();
                }
            });
    }

    const updateCheckboxFieldList = (inputData) => {  //1.2 update dataLogger field list to useState {checkboxFieldList}
        console.log('[Fn-1.2] updateCheckboxFieldList');
        dispatch({ type: 'CLEAR_GRAPH_FIELDS'});
        inputData.forEach( (item, index) => {
            dispatch({type: 'UPDATE_GRAPH_FIELDS', payload: {id: index, name: item, isChecked: false}})
        });
    }

    const getGraphData = async () => {  //2.1 get dataLogger data from DB
        console.log('[Fn-2.1] getGraphData');
        await axios.post('/dataLogger/getMultiDataLoggerDateRange/', dataPost, { headers: {Authorization: loginState.token} } )
        .then(response => {
            //console.log('Series request top level size: ', response.data.length);
            updateGraphSeries(response.data);  //generate each series data selected by user, eg. temp...
        })
        .catch(error => {
            console.log('[Error] Get Graph Data: ', error.message);
            if(error.response.status === 403){  //If Error 403 means user is not authorised or Token has expired, route back to login screen...
                //signOut();
            }
        });
    }

    const updateGraphSeries = (inputData) => {  //2.2 dataLogger data from DB, and set to useState {series}
        console.log('[Fn-2.2] updateGraphSeries');
        //console.log('>>> input.data: ', inputData);
        dispatch({ type: 'CLEAR_GRAPH_DATA'});

        graphFields.forEach(field => { //this is not working, before all fields can be loaded, the next fn runs...
            let fieldLineArray = [];
            if(field.isChecked){  //Only process fields that are checked in pull up control, we need to split each field data loading to PER dataLoggerId
                dataPost.dataLoggerIdSet.forEach( (dataLoggerPos, index) => { //Per dataLogger
                    fieldLineArray = [];  //we need to reset this for PER dataLogger, per field else d1 and d2 will show the same thing
                    inputData.forEach(item => { //Per Field in each dataLogger
                        Object.keys(item).forEach(key => {  //loop thru selected fields and load the data into fieldLineArray[]
                            if(key === field.name && item.dataLoggerId === dataLoggerPos){  //dataLoggerPos = dataLoggerId in array
                                fieldLineArray.push([item.timestamp, item[key]]);
                            }
                        })
                    });
                    //xAxisIndex, yAxisIndex will be '0' or '1' according to echarts options defined, value taken from 'index'.
                    dispatch({type: 'ADD_GRAPH_DATA', payload: {xAxisIndex: index, yAxisIndex: index, name: field.name, type: 'line', data: fieldLineArray} })
                });
            }
        });
    }

    const updateCheckbox = (id, name, isChecked) => {  //this fn is called everytime a checkbox is ticked
        //console.log('>>> checkbox updated: ', id, ' - ', name);
        dispatch({ type: 'UPDATE_GRAPH_FIELD_CHECKBOX', payload: {id: id, name: name, isChecked: isChecked} });  //set redux checkbox 
    }

    const refreshGraph = () => {  //refreshes the graph with updates to checkbox fields changes
        getGraphData();
    }

    useEffect(() => { //no useIsFocused in React.js to apply here...
        console.log('*** GraphScreen usEffect()'); 
        getDataLoggerFieldList();  //Fn.S1 - 1.1 get the list of dataLoggerFields from DB, then update useState {checkboxFieldList}
        getGraphData();
        
        // 2022-02-22 The functions called are not exclusive to the useEffect, causing missing deps or endless loop when we include it in [].  useMemo does not work too as it does not retrieve or update the Redux well.
        // Hence the below line will ignore this rule, removing the warning: React Hook useEffect has missing dependencies
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return(
        <div className="container-fluid">
            <Modal show={showModal} onHide={ ()=> {handleModalClose();}}>
                <Modal.Header closeButton><Modal.Title>Select Date Range</Modal.Title></Modal.Header>
                <Modal.Body>
                    <DatePicker 
                        filterDate={d => { return new Date() > d; }}
                        showTimeSelect
                        placeholderText='Select Start Date'
                        dateFormat="yyyy-MM-dd HH:mm:ss.s" //MMMM d, yyyy h:mmaa
                        selected={startDate} 
                        selectsStart 
                        startDate={startDate}
                        endDate={endDate} 
                        onChange={date => {
                            setStartDate(date);
                            setStartDateFormatted((format(date, 'yyyy-MM-dd HH:mm:ss.s')).toString());
                            console.log('>>> Start Date (formatted): ', startDateFormatted);
                            }} 
                    />
                    <DatePicker 
                        filterDate={d => { return new Date() > d; }}
                        showTimeSelect 
                        placeholderText='Select End Date'
                        dateFormat="yyyy-MM-dd HH:mm:ss.s" //MMMM d, yyyy h:mmaa
                        selected={endDate} 
                        selectsEnd 
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        onChange={date => {
                            setEndDate(date);
                            setEndDateFormatted((format(date, 'yyyy-MM-dd HH:mm:ss.s')).toString());
                            console.log('>>> End Date (formatted): ', endDateFormatted);
                        }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={ ()=> {handleModalClose();}}>Cancel</Button>
                    <Button variant="primary" onClick={ ()=> {handleModalClose();}}>Confirm</Button>
                </Modal.Footer>
            </Modal>

            <div style={{ marginBottom: 5, marginTop: 8, fontSize: 20, fontWeight: 'bold', textAlign: 'center' }}>Graph Screen</div>

            <div className="graph-container">
                <ReactEcharts 
                    option={option} 
                    style={{ height: '70vh' }}
                    notMerge={true}
                />
            </div>

            <Form>
            <div className="graph-control-container">
                { dataPost.dataLoggerIdSet.map( item => { 
                    return(
                        <div className="graph-control-item">
                            <Form.Check 
                                type="checkbox"
                                id={item}
                                label={item}
                                //checked={isChecked}
                                //onClick={()=> {updateCheckbox(id, name, isChecked)} }
                            />
                        </div>
                    );
                })}
                
                {graphFields.map(graphField => {
                    const {id, name, isChecked } = graphField;
                    return(
                        <div className="graph-control-item">
                            <Form.Check 
                                type="switch"
                                id={id}
                                label={name}
                                checked={isChecked}
                                onClick={()=> {updateCheckbox(id, name, isChecked)} }
                            />
                        </div>
                    )}
                )}

                <div className="custom-button" 
                    style={{ backgroundColor: buttonColor, borderRadius: '1vh', }} 
                    onMouseOut={() => setButtonColor('#0D6EFD')}
                    onMouseOver={() => setButtonColor('#0d5dfd')}
                    onMouseDown={() => setButtonColor('#5d0dfd')}
                    onMouseUp={() => {
                            setButtonColor('#0d5dfd');
                            dispatch({ type: 'UNCHECK_ALL_GRAPH_FIELD_CHECKBOXS' } );  //set redux checkbox 
                            }}
                    ><div style={{ fontSize: '2.4vh' }}>✘</div>
                </div>

                <div className="custom-button" 
                    style={{ backgroundColor: buttonColor }} 
                    onMouseOut={() => setButtonColor('#0D6EFD')}
                    onMouseOver={() => setButtonColor('#0d5dfd')}
                    onMouseDown={() => setButtonColor('#5d0dfd')}
                    onMouseUp={() => {
                            setButtonColor('#0d5dfd');
                            dispatch({ type: 'CHECK_ALL_GRAPH_FIELD_CHECKBOXS' } );  //set redux checkbox 
                            }}
                    ><div style={{ fontSize: '2.4vh' }}>✓</div>
                </div>

                <div className="custom-button" 
                    style={{ backgroundColor: buttonColor }} 
                    onMouseOut={() => setButtonColor('#0D6EFD')}
                    onMouseOver={() => setButtonColor('#0d5dfd')}
                    onMouseDown={() => setButtonColor('#5d0dfd')}
                    onMouseUp={() => {
                            setButtonColor('#0d5dfd');
                            handleModalShow();
                            }}
                    ><div style={{ fontSize: '2.4vh' }}>Select Dates</div>
                </div>
                

                <div className="custom-button" 
                    style={{ backgroundColor: buttonColor }} 
                    onMouseOut={() => setButtonColor('#0D6EFD')}
                    onMouseOver={() => setButtonColor('#0d5dfd')}
                    onMouseDown={() => setButtonColor('#5d0dfd')}
                    onMouseUp={() => {
                            setButtonColor('#0d5dfd');
                            refreshGraph();
                            }}
                    ><div style={{ fontSize: '2.4vh' }}>Refresh</div>
                </div>
            </div>
            </Form>

        </div>
    );
}
export default GraphScreen;
